import AuthManager from '@services/AuthManager';

export function setupAxios(axios) {
    axios.interceptors.request.use(
        (config) => {
            const authToken = (config && config.token) || AuthManager.getFullToken();
            const reseller_uuid = AuthManager.getResellerId();
            config.headers.Authorization = config.headers.Authorization || `Bearer ${authToken}`;
            config.headers.Accept = 'application/json';
            config.headers.resellerUuid = reseller_uuid;

            return config;
        },
        err => Promise.reject(err),
    );

    axios.interceptors.response.use(
        response =>
            response
        ,
        (error) => {
            if (error.response) {
                // for unauthorized response, redirect on Partner
                if (error.response.status === 401) {
                    AuthManager.removeLocalStorageData();
                    const { origin, search, pathname } = window.location;
                    if (pathname === '/account/service_login') {
                        window.location.assign(`${origin}/app/account${search}`);
                    } else {
                        const urlSearchParams = new URLSearchParams(decodeURIComponent(search));
                        const redirectTo = urlSearchParams.get('redirect_to') || urlSearchParams.get('redirectTo');
                        if (redirectTo
                            && !urlSearchParams.get('client_id')) {
                            window.location.assign(`/app/account?redirectTo=${redirectTo}`);
                            return;
                        }
                        const redirectURL = `${origin}${pathname}${encodeURIComponent(decodeURIComponent(search))}`;
                        window.location.assign(`/app/account?redirectTo=${redirectURL}`);
                    }
                }
                // handle Internal Server Error
                if (error.response.status === 500) {
                    error.message = 'Some error occurred, please try again later';
                }
            }
            return Promise.reject(error);
        },
    );
}
